<template>
  <div>
    <b-form-select
      :value="selectedValue"
      :options="options"
      @change="onChangeStatus"
    ></b-form-select>
    <small v-if="!isArchive && statusName && !archiveNames.includes(statusName)" class="form-text text-muted">
      Текущий статус: <b>{{ statusName }}</b> (считается автоматически по поставкам)
    </small>
    <small v-else-if="!isArchive" class="form-text text-muted">
      Статус будет рассчитан по поставкам после сохранения
    </small>
    <b-form-checkbox
      class="mt-2"
      :checked="!!isAtRisk"
      :disabled="isArchive"
      @change="$emit('set-risk', $event)"
    >
      В зоне риска
    </b-form-checkbox>
  </div>
</template>

<script>
// Статус клиента считается автоматически (companies:recalculate-client-statuses).
// Вручную можно поставить только Black list / Ликвидирован или вернуть автоматический расчёт.
const BLACK_LIST_ID = 302;
const LIQUIDATED_ID = 370;

export default {
  props: {
    statusId: { type: [Number, String], default: null },
    statusName: { type: String, default: "" },
    isAtRisk: { type: [Boolean, Number], default: false },
  },

  data() {
    return {
      archiveNames: ["Black list", "Ликвидирован"],
      options: [
        { value: null, text: "Автоматически" },
        { value: BLACK_LIST_ID, text: "Black list" },
        { value: LIQUIDATED_ID, text: "Ликвидирован" },
      ],
    };
  },

  computed: {
    isArchive() {
      return [BLACK_LIST_ID, LIQUIDATED_ID].includes(Number(this.statusId));
    },
    selectedValue() {
      return this.isArchive ? Number(this.statusId) : null;
    },
  },

  methods: {
    onChangeStatus(value) {
      this.$emit("set-status", value);
      if (value !== null) {
        this.$emit("set-risk", false);
      }
    },
  },
};
</script>
